import React from 'react';
import { Form } from 'react-bootstrap';

const AboutEditor = ({ data, reportType, activeLang, onUpdate }) => {
    const header = data?.header || {};
    const text = data?.text || {};
    const mediaUrl = data?.mediaUrl || '';

    const handleHeaderChange = (value) => {
        onUpdate({
            ...data,
            header: {
                ...header,
                [activeLang]: value
            }
        });
    };

    const handleTextChange = (value) => {
        onUpdate({
            ...data,
            text: {
                ...text,
                [activeLang]: value
            }
        });
    };

    const handleMediaUrlChange = (value) => {
        onUpdate({
            ...data,
            mediaUrl: value
        });
    };

    return (
        <div className="pfc-about-editor">
            <div className="pfc-form-group">
                <label className="pfc-label">Header</label>
                <Form.Control
                    type="text"
                    className="pfc-input"
                    placeholder={`Enter header in ${(activeLang || '').toUpperCase()}...`}
                    value={header[activeLang] || ''}
                    onChange={(e) => handleHeaderChange(e.target.value)}
                />
            </div>

            <div className="pfc-form-group">
                <label className="pfc-label">Content</label>
                <Form.Control
                    as="textarea"
                    rows={6}
                    className="pfc-textarea"
                    placeholder={`Enter content in ${(activeLang || '').toUpperCase()}...`}
                    value={text[activeLang] || ''}
                    onChange={(e) => handleTextChange(e.target.value)}
                />
            </div>

            {/* Media URL for VizApp only */}
            {reportType === 'vizapp' && (
                <div className="pfc-form-group">
                    <label className="pfc-label">Media URL</label>
                    <Form.Control
                        type="url"
                        className="pfc-input"
                        placeholder="Enter media URL..."
                        value={mediaUrl}
                        onChange={(e) => handleMediaUrlChange(e.target.value)}
                    />
                    <small className="pfc-hint">Video or image URL for VizApp display</small>
                </div>
            )}
        </div>
    );
};

export default AboutEditor;
